import React from 'react';

const BODY_FONT = 'Inter, sans-serif';

/**
 * Image Block Renderer
 * Variants: default, full_width, with_caption
 */
export default function ImageRenderer({ props, variant }) {
  const {
    image_url = '',
    alt_text = '',
    caption = '',
    rounded = true,
  } = props;

  const roundedClass = rounded ? 'rounded-xl' : '';

  // Placeholder when no image is set
  if (!image_url) {
    return (
      <section className="py-12 px-6">
        <div className={`${variant === 'full_width' ? 'w-full' : 'max-w-2xl mx-auto'}`}>
          <div
            className={`w-full aspect-video bg-stone-100 border-2 border-dashed border-stone-300 flex items-center justify-center ${roundedClass}`}
          >
            <span className="text-sm text-stone-400" style={{ fontFamily: BODY_FONT }}>
              No image selected
            </span>
          </div>
        </div>
      </section>
    );
  }

  // Full width variant
  if (variant === 'full_width') {
    return (
      <section className="py-12">
        <img
          src={image_url}
          alt={alt_text}
          className={`w-full object-cover ${roundedClass}`}
        />
      </section>
    );
  }

  // With caption variant
  if (variant === 'with_caption') {
    return (
      <section className="py-12 px-6">
        <figure className="max-w-2xl mx-auto">
          <img
            src={image_url}
            alt={alt_text}
            className={`w-full object-cover ${roundedClass}`}
          />
          {caption && (
            <figcaption
              className="mt-3 text-sm text-stone-500 text-center"
              style={{ fontFamily: BODY_FONT }}
            >
              {caption}
            </figcaption>
          )}
        </figure>
      </section>
    );
  }

  // Default variant
  return (
    <section className="py-12 px-6">
      <div className="max-w-2xl mx-auto">
        <img
          src={image_url}
          alt={alt_text}
          className={`w-full object-cover ${roundedClass}`}
        />
      </div>
    </section>
  );
}
